import { render } from "./Subscribers.vue?vue&type=template&id=45bdf336&scoped=true"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"

import "./Subscribers.vue?vue&type=style&index=0&id=45bdf336&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bdf336"]])

export default __exports__